import { create } from 'zustand';

interface KeywordsDisplayState {
  showKeywords: boolean;
  setShowKeywords: (showKeywords: boolean) => void;
  toggleKeywords: () => void;
}

export const useKeywordsDisplayStore = create<KeywordsDisplayState>((set) => ({
  showKeywords: true,
  setShowKeywords: (showKeywords: boolean) => set({ showKeywords }),
  toggleKeywords: () => set((state) => ({ showKeywords: !state.showKeywords }))
})); 